export const crypticVaultContract =
  "0x90396B833D629082a79dc6D44E5fe369f50E3601";
